import { render } from "./EmailView.vue?vue&type=template&id=6cfd4d81"
import script from "./EmailView.vue?vue&type=script&lang=js"
export * from "./EmailView.vue?vue&type=script&lang=js"

import "./EmailView.vue?vue&type=style&index=0&id=6cfd4d81&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__